import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  standalone: true,
})
export class AlertComponent {
  @Input() status: 'danger' | 'success' | 'warning' | 'info' = 'danger';
  @Input() title?: string = '';
  @Input() message?: string;
}
